var _rect, _rect2, _rect3, _path, _line, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLeftImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 61,
    viewBox: "0 0 46 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 61,
    fill: "#E5E5E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -12182,
    y: -519,
    width: 15000,
    height: 2794,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 895,
    height: 1250,
    transform: "translate(-50 -50)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.05218 7.33638C1.05218 3.86571 3.86571 1.05218 7.33638 1.05218L44.9478 1.05218L44.9478 53.6636C44.9478 57.1343 42.1343 59.9478 38.6636 59.9478L1.05218 59.9478L1.05218 7.33638Z",
    stroke: "#2D9CDB",
    strokeWidth: 2.10437
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9.60125,
    y1: 27.3988,
    x2: 36.3988,
    y2: 27.3988,
    stroke: "#2D9CDB",
    strokeWidth: 1.2025,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 35L24 35",
    stroke: "#2D9CDB",
    strokeWidth: 1.2025,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 44L24 44",
    stroke: "#2D9CDB",
    strokeWidth: 1.2025,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 52L24 52",
    stroke: "#2D9CDB",
    strokeWidth: 1.2025,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 18L24 18",
    stroke: "#2D9CDB",
    strokeWidth: 1.2025,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9L37 9",
    stroke: "#2D9CDB",
    strokeWidth: 1.2025,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLeftImg);
export default __webpack_public_path__ + "static/media/logoLeftImg.3246127acb40d13d29e09b295caa15e5.svg";
export { ForwardRef as ReactComponent };